import { render, staticRenderFns } from "./3_2_m_recruitDetail.vue?vue&type=template&id=e4abf912&scoped=true&"
import script from "./3_2_m_recruitDetail.vue?vue&type=script&lang=js&"
export * from "./3_2_m_recruitDetail.vue?vue&type=script&lang=js&"
import style0 from "./3_2_m_recruitDetail.vue?vue&type=style&index=0&id=e4abf912&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4abf912",
  null
  
)

export default component.exports